<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("category") }}</div>
      <router-link class="btn-blue" :to="{ name: 'list Category' }"
        >{{ $tc("category") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $tc("category") }} {{ $tc("name") }}:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ category_name }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $tc("category") }} is {{ $tc("active") }}:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cat_is_active == "Y" ? "Yes" : "No" }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Is {{ $tc("super") }} {{ $tc("category") }}:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{
              is_super_category == "Y" ? "Yes" : "No"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import MasterService from "@/services/MasterService";
import MyCinemaService from "@/services/MyCinemaService";

export default {
  data() {
    return {
      submitted: false,
      category_name: null,
      cinema_name: null,
      cinema_id: null,
      cat_is_active: true,
      is_super_category: true,
    };
  },
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getCategory(id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getCategory: function (category_id) {
      MyCinemaService.GetSingleCategory({ category_id: category_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinema_id = data.Records[0].cinema_id;
            this.category_name = data.Records[0].category_name;
            this.cat_is_active = data.Records[0].cat_is_active;
            this.is_super_category = data.Records[0].is_super_category;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/MyCinemas/Category/ViewCategory.vue